import ReleaseFileInstance from './ReleaseFileInstance.component';

export default ReleaseFileInstance;
